import React from 'react';

const metrics = [
  { value: '70%', label: 'Snellere responstijd' },
  { value: '24/7', label: 'Beschikbaarheid' },
  { value: '50%', label: 'Kostenbesparing' },
  { value: '95%', label: 'Klanttevredenheid' }
];

export function MetricsPanel() {
  return (
    <div className="space-y-6">
      <h3 className="text-2xl font-bold text-gray-900">
        Meetbare Impact op Uw Bedrijf
      </h3>
      <div className="grid grid-cols-2 gap-6">
        {metrics.map((metric, index) => (
          <div key={index} className="space-y-2">
            <p className="text-3xl font-bold text-brand-600">{metric.value}</p>
            <p className="text-sm text-gray-600">{metric.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}